import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M21,80.4c-1.5,0-2.8-1.2-2.8-2.8V22.3c0-1.5,1.2-2.8,2.8-2.8l13.6,0c2.1,0,3,0.1,3.9,0.7l3.1,2.7 H79c1.5,0,2.8,1.2,2.8,2.8v51.9c0,1.5-1.2,2.8-2.8,2.8H21z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M21,80.4c-1.5,0-2.8-1.2-2.8-2.8V22.3c0-1.5,1.2-2.8,2.8-2.8l13.6,0c2.1,0,3,0.1,3.9,0.7l3.1,2.7 H79c1.5,0,2.8,1.2,2.8,2.8v51.9c0,1.5-1.2,2.8-2.8,2.8H21z"
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M79,21H42.3l-2.6-2.2l-0.1-0.1c-1.5-1.1-3-1.1-5.3-1.1l-13.4,0c-2.6,0-4.8,2.1-4.8,4.8v55.3 c0,2.6,2.1,4.8,4.8,4.8h58.1c2.6,0,4.8-2.1,4.8-4.8V35.3v-9.5C83.8,23.1,81.7,21,79,21z M79,24.1c0.9,0,1.7,0.8,1.7,1.7v5.1 c-0.5-0.2-1.1-0.3-1.7-0.3H58.6c-0.8,0-1.5,0-2-0.1c-2.2-0.3-4.9-1.4-6.4-2.6l-4.4-3.7H79z M80.7,77.7c0,0.9-0.8,1.7-1.7,1.7H21 c-0.9,0-1.7-0.8-1.7-1.7V22.3c0-0.9,0.8-1.7,1.7-1.7l13.4,0c2,0,2.8,0,3.4,0.5l10.5,9c1.9,1.7,5.2,3,8,3.4c0.8,0.1,1.8,0.1,2.3,0.1 h20.4c0.9,0,1.7,0.8,1.7,1.7V77.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			style: {
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			d: "M44.6,67.4l3.9,2.6c0-1.6,0-11.6,0-11.8c0-0.6,0.3-1.1,0.9-1.4 c0.8-0.4,1.8,0.1,2.1,0.9c0.1,0.2,0.1,10.3,0.1,12.2c0,0,0,0.1,0,0.1c0.9-0.6,3.4-2.3,3.8-2.6c0.8-0.5,1.7-0.2,2.1,0.7 c0.3,0.8,0.1,1.7-0.6,2.2c-0.3,0.2-5.1,3.4-5.5,3.7c-0.2,0.1-0.3,0.3-0.4,0.4c-0.5,0.3-1,0.3-1.5,0.1h0c-0.2-0.1-0.4-0.3-0.6-0.5 c-0.2-0.1-5.5-3.6-5.8-4c-0.5-0.6-0.6-1.4-0.3-2C43,67.2,43.9,66.9,44.6,67.4L44.6,67.4z M62,66.4v-3.9v0c2.4-2.4,3.4-5.8,2.9-9.1 c-0.6-3.3-2.7-6.1-5.7-7.6c-3-1.5-6.5-1.4-9.5,0.1c-3,1.6-5,4.5-5.5,7.8H41c-1.8,0-3.4,0.8-4.6,2.1c-1.1,1.4-1.6,3.1-1.3,4.9 c0.3,1.7,1.4,3.3,2.9,4.1v3.3c-2.7-0.9-4.8-3.1-5.6-5.8c-0.8-2.7-0.3-5.7,1.4-8c1.7-2.3,4.4-3.6,7.2-3.6c0.3,0,0.5,0.1,0.7,0.1 c1.4-4.1,4.7-7.3,8.9-8.5c4.2-1.2,8.7-0.4,12.1,2.3c3.4,2.7,5.4,6.8,5.2,11.1C67.8,59.9,65.6,63.9,62,66.4L62,66.4z"
		})
	] })
});
export default SvgDownload;
